export default {
  logo: '',
  color_1: '',
  color_2: '',
  color_3: '',
  plan: '',
};
